module.exports = __webpack_public_path__ + "img/sanae kochiya_sc1.346768a4.png";